import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, TrendingUp, TrendingDown } from 'lucide-react';
import { Button } from '../components/ui/button';
import HoldingsDisplay from '../components/HoldingsDisplay';

const MyWallet = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
      {/* Header */}
      <div className="sticky top-0 bg-slate-900/95 backdrop-blur-sm border-b border-cyan-500/20 z-10">
        <div className="flex items-center justify-between px-4 py-4">
          <button onClick={() => navigate(-1)} className="flex items-center gap-2 text-cyan-400 hover:text-cyan-300">
            <ArrowLeft className="w-5 h-5" />
            <span className="font-semibold">Back</span>
          </button>
          <h1 className="text-lg font-bold text-cyan-400">My Wallet</h1>
          <div className="w-16"></div>
        </div>
      </div>

      {/* Content */}
      <div className="px-4 py-6">
        {/* Unified Balance Display with Holdings */}
        <HoldingsDisplay 
          showTotal={true}
          showIndividual={true}
          showLastUpdate={true}
          showRefreshButton={true}
          title="My Wallet Balance"
          className="mb-6"
        />

        {/* Quick Actions */}
        <div className="grid grid-cols-3 gap-3">
          <Button
            onClick={() => navigate('/recharge')}
            className="h-12 bg-green-500/20 hover:bg-green-500/30 text-green-400 border border-green-500/30 neon-button"
          >
            <TrendingUp className="w-4 h-4 mr-2" />
            Deposit
          </Button>
          <Button
            onClick={() => navigate('/withdraw')}
            className="h-12 bg-red-500/20 hover:bg-red-500/30 text-red-400 border border-red-500/30 neon-button"
          >
            <TrendingDown className="w-4 h-4 mr-2" />
            Withdraw
          </Button>
          <Button
            onClick={() => navigate('/transfer')}
            className="h-12 bg-cyan-500/20 hover:bg-cyan-500/30 text-cyan-400 border border-cyan-500/30 neon-button"
          >
            Transfer
          </Button>
        </div>
      </div>
    </div>
  );
};

export default MyWallet;